import { atom } from "recoil";

export const localeState = atom({
  key: "localeState",
  default: "en",
});
